import Axios from "axios";

export default function getGuest(guestId, email = "", setUser) {
  return (dispatch) => {
    dispatch({
      type: "Loading",
      payload: true,
    });
    Axios({
      method: "GET",
      url: `${process.env.REACT_APP_BASE_URL}/getGuest/${guestId}`,
      params: email ? { email } : {},
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((response) => {
        setUser(response.data.data[0]);
        return dispatch({
          type: "Loading",
          payload: false,
        });
      })
      .catch((err) => {
        dispatch({
          type: "Loading",
          payload: false,
        });
      });
  };
}
